import { createAsyncThunk } from "@reduxjs/toolkit"
import { AppDispatch, RootState } from "@myRedux/store"
import { IApiClient } from "api/api"

interface AsyncThunkDependencies {
  apiClient: IApiClient,
  authClient: IApiClient
}

export const createAppAsyncThunk = createAsyncThunk.withTypes<{
  state: RootState
  dispatch: AppDispatch
  rejectValue: string
  extra: AsyncThunkDependencies
}>()